module.exports = __webpack_public_path__ + "referral-card/referral-card-25f48edc6e2f5b414e568df9648e9768.png";